import { useMemo } from 'react';
import { isFirefox } from '@/utils';

export function useIsFirefox(): boolean {
	return useMemo(() => isFirefox(), []);
}
